import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PagedResponseModel } from 'src/app/models/common/paged-response.model';
import { PagedSearchModel } from 'src/app/models/common/paged-search.model';
import { NewsListItemModel } from 'src/app/models/news/news-list-item.model';
import { NewsSearchModel } from 'src/app/models/news/news-search.model';
import { ApiService } from 'src/app/services/api.service';
import { BasePagedPage } from '../base-paged-page';

@Component({
    selector: 'app-news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss'],
    standalone: false
})
export class NewsComponent extends BasePagedPage<NewsSearchModel, NewsListItemModel> implements OnInit {

  public constructor(private mApiService: ApiService, private mRoute: Router) {
    super();
  }
  ngOnInit(): void {
    this.getData(1);
  }

  public addNew() {
    this.mRoute.navigate(['/news/edit/new']);
  }

  public deleteItem(id: string) {
    if (!confirm('Удалить этот новость?')) {
      return;
    }

    this.isBusy = true;
    this.mApiService.delete(`/api/admin/news/${id}`).subscribe({
      next: () => {
        this.getData(this.page);
      },
      error: () => this.isBusy = false
    });
  }

  public getData(page?: number | undefined): void {
    if (!page) { return; }

    this.isBusy = true;

    this.mApiService.getWithParams<PagedSearchModel<NewsSearchModel>, PagedResponseModel<NewsListItemModel>>('/api/admin/news/list', {
      page: page,
      pageSize: 20,
      search: this.search
    }).subscribe({
      next: r => {
        this.items = r.items;

        for (const item of r.items) {
          if (item.endDateUtc) {
            item.endDateUtc += '+00:00';
          }

          if (item.startDateUtc) {
            item.startDateUtc += '+00:00';
          }
        }

        this.page = page;
        this.pages = r.pages;

        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }
}
